// src/Pages/MDCreateSI.js
import React from 'react';
import "../Styles/CreateUser.css";
import * as yup from "yup";
import { useNavigate, useParams } from 'react-router-dom';
import { ErrorMessage, Formik, Form, Field } from "formik";
import Axios from "axios";
import { toast } from 'react-toastify';
import MDUserProfileHeader from './MDUserProfileHeader';

const MDCreateSI = () => {
  const navigate = useNavigate();
  const { mdId } = useParams();

  const handleCreateUser = (values, { resetForm }) => {
    Axios.post(`/create_si`, {
      mdId,
      firstname: values.firstname,
      lastname: values.lastname,
      companyname: values.companyname,
      email: values.email,
      yubikey: values.yubikeyserialnumber,
      adminEmail: localStorage.getItem('userEmail'),
      role: "Admin", // hard-coded: SI Admin only
    })
      .then((res) => {
        if (res?.data?.success) {
          toast.success(res.data.msg || "SI Admin created!");
          resetForm();
        } else {
          toast.error(res?.data?.msg || "Failed to create SI Admin.");
        }
      })
      .catch(() => toast.error("Network error. Please try again."));
  };

  const validations = yup.object().shape({
    firstname: yup.string().required("First name is mandatory"),
    lastname: yup.string().required("Last name is mandatory"),
    companyname: yup.string().required("Company name is mandatory"),
    email: yup.string().email("Invalid email").required("Email is mandatory"),
    yubikeyserialnumber: yup.string().required("YubiKey Serial Number is mandatory"),
  });

  return (
    <div className="dashboard">
      <MDUserProfileHeader isAdmin={true} />
      <div className="all-users-card">
        <h1 className="Title-alluser">Create System Integrator Admin</h1>
        <Formik
          initialValues={{
            firstname: '',
            lastname: '',
            email: '',
            companyname: '',
            yubikeyserialnumber: '',
          }}
          onSubmit={handleCreateUser}
          validationSchema={validations}
        >
          <Form className="register-form">
            <div className="register-form-group">
              <Field name="firstname" type='text' className="register-form-firstname-field" placeholder="First name" />
              <ErrorMessage component="span" name="firstname" className="adduser-form-error" />
            </div>

            <div className="register-form-group">
              <Field name="lastname" type='text' className="register-form-lastname-field" placeholder="Last name" />
              <ErrorMessage component="span" name="lastname" className="adduser-form-error" />
            </div>

            <div>
              <Field name="companyname" type='text' className="register-form-companyname-field" placeholder="Company name" />
              <ErrorMessage component="span" name="companyname" className="adduser-form-error" />
            </div>

            <div className="register-form-group">
              <Field name="email" type='text' className="register-form-email-field" placeholder="Email" />
              <ErrorMessage component="span" name="email" className="adduser-form-error" />
            </div>

            <div className="register-form-group">
              <Field name="yubikeyserialnumber" type='text' className="register-form-yubikeyserialnumber-field" placeholder="YubiKey Serial Number" />
              <ErrorMessage component="span" name="yubikeyserialnumber" className="adduser-form-error" />
            </div>

            <button className="createuser-button" type="submit">
              Create System Integrator Admin
            </button>
          </Form>
        </Formik>
      </div>
    </div>
  );
};

export default MDCreateSI;
